export const SEARCH_AGAIN_BUTTON = "Search again";
export const GO_BACK_BUTTON = "Go back";
export const SHOP_ERROR_TITLE =
  "Uh oh! We were unable to process your shop request.";
export const SHOP_MISSING_ROOMS_ERROR =
  "Uh oh! This hotel has no rooms available for your search criteria.";
export const SHOP_ERROR_SUBTITLE = "Something went wrong.";
export const SHOP_MISSING_PAY_NOW_RATES_TITLE =
  "The rate selected is unavailable at this time";
export const SHOP_MISSING_PAY_NOW_RATES_SUBTITLE =
  "Please select another hotel in the search result.";
